<div mat-dialog-content>
    <div class="docLevel-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-documentLevelAccess (closeDialog)="onClose()" [docLevelformId]="docLevelformId"></app-documentLevelAccess>
</div>